module.exports = __webpack_public_path__ + "img/v2.4.6fcce21a.png";